import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog dialog--info" }
const _hoisted_2 = { class: "dialog__body" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "number" }
const _hoisted_5 = {
  key: 0,
  class: "dialog__spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "slide",
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-overlay",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "dialog__close",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
                  }),
                  _createElementVNode("header", null, _toDisplayString(_ctx.$t("account.bookings.amendment.title")), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (_ctx.redirect(index + 1, option.type)),
                        key: index,
                        class: _normalizeClass({ disabled: _ctx.disableOption(option.type) })
                      }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1) + ".", 1),
                        _createElementVNode("span", null, _toDisplayString(option.name), 1)
                      ], 10, _hoisted_3))
                    }), 128))
                  ])
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_BaseSpinner, { size: 50 })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}